import React from 'react';

export const GrillIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.08779 14.5712L5.50952 18.4535"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.7827 14.5712L18.361 18.4535"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.4017 8.10046C20.4017 10.7982 18.4108 14.6307 11.9402 14.6307C5.96743 14.6307 3.47876 10.7982 3.47876 8.10046"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9402 9.76287C16.6134 9.76287 20.4017 8.92052 20.4017 7.88144C20.4017 6.84235 16.6134 6 11.9402 6C7.2671 6 3.47876 6.84235 3.47876 7.88144C3.47876 8.92052 7.2671 9.76287 11.9402 9.76287Z"
          stroke="#696F79"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9399 17.0099V14.9891"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4372 6.5177L8.62549 9.25524"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2847 6.62732L13.3535 9.554"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.7502 8.78742C21.5267 9.39465 22.3629 9.53402 22.7412 9.1856C22.8709 9.08253 22.9621 8.93875 23 8.77747"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.24976 8.78742C2.4733 9.39465 1.6371 9.53402 1.25882 9.1856C1.12911 9.08253 1.03792 8.93875 1 8.77747"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
